module.exports = __webpack_public_path__ + "img/1492582546.73e867bb.jpg";